const SucssesIcon = () => {
    return (
        <div style={{width: '27px' , height: '27px'}}>
            <svg width="27" height="27" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M436.891 74.8643C337.072 -24.9548 174.683 -24.9548 74.8643 74.8643C-24.9548 174.661 -24.9548 337.093 74.8643 436.891C124.763 486.811 190.32 511.75 255.877 511.75C321.434 511.75 386.97 486.811 436.89 436.891C536.709 337.093 536.709 174.661 436.891 74.8643ZM398.96 185.626L249.627 334.96C245.467 339.12 240.006 341.211 234.544 341.211C229.083 341.211 223.621 339.12 219.461 334.96L134.128 249.627C125.787 241.286 125.787 227.803 134.128 219.462C142.469 211.121 155.952 211.121 164.293 219.462L234.544 289.713L368.795 155.462C377.136 147.121 390.619 147.121 398.96 155.462C407.301 163.802 407.301 177.285 398.96 185.626Z" fill="white"/>
            </svg>
        </div>
    );
}

export default SucssesIcon;